/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Share_Record_Line_LoadInputs */

const en_us2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heaviest load yet · ${i?.date}`)
};

const pt_br2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga mais alta até hoje · ${i?.date}`)
};

const es_419_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El mayor peso hasta hoy · ${i?.date}`)
};

const pt_pt2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga mais alta até hoje · ${i?.date}`)
};

const fr_fr2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Charge la plus lourde à ce jour · ${i?.date}`)
};

const de_de2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schwerstes Gewicht bisher · ${i?.date}`)
};

const it_it2_share_record_line_load = /** @type {(inputs: Share_Record_Line_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carico più alto finora · ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Heaviest load yet · {date}" |
*
* @param {Share_Record_Line_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_record_line_load = /** @type {((inputs: Share_Record_Line_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Record_Line_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_record_line_load(inputs)
	if (locale === "es-419") return es_419_share_record_line_load(inputs)
	if (locale === "pt-PT") return pt_pt2_share_record_line_load(inputs)
	if (locale === "fr-FR") return fr_fr2_share_record_line_load(inputs)
	if (locale === "de-DE") return de_de2_share_record_line_load(inputs)
	if (locale === "it-IT") return it_it2_share_record_line_load(inputs)
	return en_us2_share_record_line_load(inputs)
});
export { share_record_line_load as "share.record_line_load" }